<template>
  <div>
    <b-card
      v-can="'add-received-failed-order'"
    >
      <b-row class="mb-1">
        <b-col>
          <form-builder
            ref="formbuilder"
            v-model="formData"
            :on-submit="onSubmit"
            grid-class="px-1 row"
            :form-structure="formStructure"
            @waybillPaste="handleWaybillPaste"
            @waybillScan="handleWaybillScan"
          >
            <template slot="buttons">
              <b-col
                cols="12"
                md="3"
                class="d-flex mobile-width-align"
              >
                <b-button
                  type="submit"
                  class="vh-5 mt-2 custom-button-color"
                  style="height: 37px;"
                  :disabled="!(formData.waybill_number) || loadingResponse"
                >
                  {{ loadingResponse ? 'Submitting...' : 'Submit' }}
                </b-button>
              </b-col>
            </template>
          </form-builder>
          <b-form-checkbox
            v-model="auto_submit"
            :value="true"
            class="ml-1 mt-sm-1"
          >
            <small>
              Auto Submit
            </small>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-card>

    <b-card-actions
      title="Filters"
      action-collapse
      collapsed
    >
      <b-row class="mb-0">
        <b-col
          md="4"
          sm="2"
        >
          <b-form-group
            label="Returned Date"
            label-for="basicInput"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['status_date']"
                :opens="'right'"
                @update="updateDateRange('status_date', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Apply and Clear Filters -->
      <b-row class="mt-0">
        <b-col>
          <filter-buttons
            :filter-data="filters"
            :apply-filters="applyFilters"
            :clear-filters="clearFilters"
          />
        </b-col>
      </b-row>
    </b-card-actions>

    <b-card no-body>
      <b-row class="mb-1 mr-1 ml-1">
        <b-col
          class="d-flex align-items-center justify-content-start"
          cols="12"
          md="4"
        >
          <bulk-submit
            v-if="$can('bulk-update-operation') && $can('add-received-failed-order')"
            :status-key="status_key"
            :selected-waybills="selectedWaybillArray"
            @bulkSubmit="onClickBulkAction"
          />
        </b-col>
        <b-col
          class="d-flex justify-content-between align-items-center mb-1 mb-md-0"
          md="8"
        >
          <b-button
            type="submit"
            class="mt-2 ml-0 ml-md-3 custom-button-color-blur"
            :disabled="false"
          >
            Scanned Orders : {{ submitCount }}
          </b-button>
          <TableButtons
            class="ml-2 mt-2"
            :items="rows"
            :json_fieldz="json_fields"
            :name="`ReceivedFailedOrders - Page ${page}.xls`"
            :bulkname="`ReceivedFailedOrders.xls`"
            :fetch="fetchOrderListNoPagination"
            @refresh="onClickRefresh"
          />
        </b-col>
      </b-row>
      <b-row class="mb-1 mr-1 ml-1">
        <b-col
          class="d-flex align-items-center justify-content-start"
          cols="12"
          md="6"
        >
          <div class="font-weight-bolder">
            {{ `${selectedWaybillArray.length} record${selectedWaybillArray.length === 1 ? '':'s'}` }} selected
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <b-table
              :per-page="perPage"
              :fields="columns"
              :items="rows"
              hover
              responsive
              striped
              show-empty
              sticky-header="100vh"
              class="hide-vertical-scroll"
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #head(id)>
                <div class="d-flex align-items-start">
                  <div>
                    <b-form-checkbox
                      id="selectAllCheckbox"
                      v-model="selectAllCheckbox"
                      name="selectAllCheckbox"
                      @change="onClickSelectAllCheckbox()"
                    />
                  </div>
                </div>
              </template>
              <template #cell(id)="data">
                <div class="d-flex align-items-start">
                  <div>
                    <div class="font-weight-bolder">
                      <b-form-checkbox
                        v-model="selectedWaybillArray"
                        :value="data.item.waybill_number"
                      />
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(waybill_number)="data">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :text="avatarText(data.item.customer_name)"
                    size="32"
                    variant="light-primary"
                  />
                  <div>
                    <div
                      class="font-weight-bolder ml-1 text-primary"
                      @click="onClickViewOrder(data.item.id)"
                    >
                      {{ data.value }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ __dateTimeFormatter(data.item.created_at) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(origin_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder ml-1">
                      CITY - {{ data.item.origin_city.name }}
                    </div>
                    <div class="font-small-2 ml-1">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>

              <template #cell(destination_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder ml-1">
                      CITY - {{ data.item.destination_city.name }}
                      <!--                    </b-badge>-->
                    </div>
                    <div class="font-small-2 ml-1">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(customer_email)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder ml-1">
                      {{ data.item.customer_name }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ data.value }}
                    </div>
                    <div class="font-small-2  ml-1">
                      <div><b>Primary number: </b>{{ data.item.customer_phone }}</div>
                    </div>
                    <div
                      v-if="data.item.customer_secondary_phone !== null"
                      class="font-small-2  ml-1"
                    >
                      <div><b>Second number: </b>{{ data.item.customer_secondary_phone }}</div>
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ data.item.customer_address }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(created_at)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>
              <template #cell(order_current_status.key)="data">
                <order-status-badge :status-key="data.value" />
              </template>
              <template #cell(cod)="data">
                {{ __numberWithCommas(data.value, true) }}
              </template>
              <template #cell(collected_cod)="data">
                {{ __numberWithCommas(data.value, true) }}
              </template>
              <template #cell(delivery_charge)="data">
                {{ __numberWithCommas(data.value, true) }}
              </template>
              <template #cell(weight)="data">
                {{ (data.value).toLocaleString() }}
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="12"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item @click="onClickViewOrder(data.item.id)">
                    <feather-icon icon="EyeIcon" />
                    View Details
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-overlay>

          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                class="d-flex align-items-center justify-content-sm-start"
                md="3"
              >
                <label class="width-75">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block width-125 mr-1"
                />
              </b-col>
              <!-- Pagination -->
              <b-col
                class="d-flex align-items-center justify-content-sm-end"
                md="9"
              >
                <span class="text-muted mr-1 pagination-text mt-1 mt-md-0">Showing {{ meta.from }} to {{ meta.to }} of
                  {{ meta.total }} entries</span>
                <b-pagination
                  v-model="page"
                  :per-page="perPage"
                  :total-rows="(meta.total)? meta.total : 0"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <view-order-modal ref="viewOrderModal" />
    <bulk-action-modal
      ref="bulkActionModal"
      :form_structure="formStructure"
      :status_key="status_key"
      :selected_waybill_array="selectedWaybillArray"
    />
  </div>
</template>

<script>
import {
  BAvatar,
  BRow,
  BCol,
  BTable,
  BCard,
  BButton,
  BFormGroup,
  BPagination,
  BOverlay,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
  VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import Filter from '@core/mixins/filter'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import vSelect from 'vue-select'
import displayAmountWithCurrency from '@core/mixins/currency'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import { avatarText } from '@core/utils/filter'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import FormBuilder from '@/libs/builders/form-builder/FormBuilder.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import ViewOrderModal from '@/components/orders/ViewOrderModal.vue'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import BulkActionModal from './bulk-actions/BulkActionModal.vue'
import BulkSubmit from './bulk-actions/BulkSubmit.vue'

const orderRepository = RepositoryFactory.get('order')
const waybillSettingsRepository = RepositoryFactory.get('waybillSetting')

export default {
  name: 'KeyTwentyOne',
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    OrderStatusBadge,
    BAvatar,
    AdvancedDateFilter,
    BRow,
    BCol,
    BTable,
    BCard,
    FormBuilder,
    BButton,
    BFormGroup,
    BPagination,
    BOverlay,
    BulkActionModal,
    BFormCheckbox,
    BCardActions,
    vSelect,
    BDropdown,
    BDropdownItem,
    ViewOrderModal,
    FilterButtons,
    BulkSubmit,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, displayAmountWithCurrency],
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    status_key: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      avatarText,
      submitCount: 0,
      dataLoading: false,
      rows: [],
      columns: [
        {
          key: 'id',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'waybill_number',
          label: 'WayBill Number',
          sortable: true,
        },
        {
          key: 'customer_name',
          label: 'Customer Name',
          sortable: true,
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'origin_warehouse',
          label: 'Origin',
          sortable: true,
        },
        {
          key: 'destination_warehouse',
          label: 'Destination',
          sortable: true,
        },
        {
          key: 'customer_email',
          label: 'Customer Contact',
          sortable: true,
        },
        {
          key: 'cod',
          label: 'COD',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'collected_cod',
          label: 'Collected Cod',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'delivery_charge',
          label: 'Delivery Charge',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'weight',
          label: 'Net Weight',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'order_current_status.key',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
        },
      ],
      json_fields: {
        'Waybill Number': 'waybill_number',
        'Origin City': {
          field: 'origin_city.name',
          callback: value => `"${value}"`,
        },
        'Origin Warehouse': {
          field: 'origin_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Destination City': {
          field: 'destination_city.name',
          callback: value => `"${value}"`,
        },
        'Destination Warehouse': {
          field: 'destination_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value}"`,
        },
        'Customer Address': {
          field: 'customer_address',
          callback: value => `"${value}"`, // Wrap the address in double quotes
        },
        'Customer Phone': 'customer_phone',
        'Second Phone Number': 'customer_secondary_phone',
        COD: {
          field: 'cod',
          callback: value => `"${value}"`,
        },
        'Delivery Charge': {
          field: 'delivery_charge',
          callback: value => `"${value}"`,
        },
        'Collected Cod': 'collected_cod',
        'Net Weight': 'weight',
        Status: 'order_current_status.name',
      },
      perPage: 20,
      pageOptions: [10, 20, 50],
      filters: {
        status_date: {
          startDate: null,
          endDate: null,
        },
      },
      total: 0,
      loadingResponse: false,
      meta: {},
      page: 1,
      formData: {},
      formStructure: [
        {
          type: 'input',
          placeholder: '',
          inputType: 'text',
          title: 'Waybill Number',
          value: 'waybill_number',
          class: 'col-12 col-md-3',
          validation: 'required',
        },
      ],
      selectedWaybillArray: [],
      selectAllCheckbox: false,
      auto_submit: false,
      waybillMaxLength: 0,
      isSubmitting: false,
    }
  },
  watch: {
    page() {
      this.fetchOrderList()
    },
    perPage() {
      this.fetchOrderList()
    },
    formData: {
      handler(val) {
        const waybill = val.waybill_number
        // eslint-disable-next-line no-empty
        if (waybill.length === this.waybillMaxLength && this.auto_submit) {
          this.onSubmit()
        }
      },
      deep: true,
    },
    loadingResponse(newValue) {
      /* eslint no-underscore-dangle: 0 */
      this.__toggleDisableInput('Waybill Number', newValue)
    },
  },
  async mounted() {
    this.fetchOrderList()
    this.getWaybillMaxLength()
  },
  methods: {
    async getOrderDetails(waybill) {
      try {
        const { data } = (await orderRepository.getOrderDetails(waybill)).data
        if (data.waybill_number === waybill) {
          // await this.onSubmit()
        } else {
          this.showErrorMessage('Invalid waybill number!!')
        }
      } catch (e) {
        this.showErrorMessage('Invalid waybill number!!')
      }
    },
    async getOrderList() {
      this.dataLoading = true
      this.rows = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await orderRepository.getOrderListByKey(this.status_key, this.page, filterQuery, this.perPage))
        this.rows = data.data
        this.meta = data.meta
        this.submitCount = 0
        // eslint-disable-next-line no-empty
      } catch (e) {

      }
      this.dataLoading = false
    },
    async getOrderListNoPagination() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await orderRepository.getOrderListByKeyNoPagination(this.status_key, this.filterQuery))
        return data.data
        // eslint-disable-next-line no-empty
      } catch (e) {
        return []
      }
    },
    async fetchOrderList() {
      this.dataLoading = true
      this.rows = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await orderRepository.fetchOrderListByKey(this.status_key, this.page, filterQuery, this.perPage))
        this.rows = data.data
        this.meta = data.meta
        this.submitCount = 0
        // eslint-disable-next-line no-empty
      } catch (e) {

      }
      this.dataLoading = false
    },
    async fetchOrderListNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await orderRepository.fetchOrderListByKeyNoPagination(this.status_key, filterQuery))
        return data.data
        // eslint-disable-next-line no-empty
      } catch (e) {
        return []
      }
    },
    async getWaybillMaxLength() {
      try {
        const maxWaybill = (await waybillSettingsRepository.getLongestWaybillNumberLength()).data.data
        this.waybillMaxLength = maxWaybill.max_length
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    handleWaybillPaste(pastedText) {
      if (pastedText) {
        if (this.auto_submit) {
          setTimeout(() => {
            this.onSubmit()
          }, 0)
        }
      }
    },
    async handleWaybillScan(waybill) {
      if (waybill && this.auto_submit) {
        this.onSubmit()
      }
    },
    async onSubmit() {
      if (this.isSubmitting) return // Prevent multiple submissions
      this.isSubmitting = true

      this.loadingResponse = true
      try {
        const payload = {
          waybill_numbers: [],
        }
        payload.waybill_numbers.push(this.formData.waybill_number)
        payload.status_key = this.status_key
        payload.other_details = {}

        await orderRepository.updateOrderStatus(payload)
        this.showSuccessMessage('Order updated successfully')
        this.submitCount += 1
        this.loadingResponse = false
        this.clearFormData()
      } catch (e) {
        this.loadingResponse = false
        this.clearFormData()
        this.convertAndNotifyError(e)
      }
      this.isSubmitting = false
    },
    clearFormData() {
      this.$nextTick(() => {
        this.$refs.formbuilder.reset()
        // eslint-disable-next-line no-underscore-dangle
        this.__focusInputField('Waybill Number')
      })
    },
    applyFilters() {
      this.fetchOrderList()
      this.onClickDeselectAll()
    },
    clearFilters() {
      this.filters = {
        status_date: {
          startDate: null,
          endDate: null,
        },
      }
      this.$nextTick(() => {
        this.fetchOrderList()
      })
    },
    onClickBulkAction() {
      this.$refs.bulkActionModal.openModal()
    },
    onClickSelectAll() {
      this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
    },
    onClickDeselectAll() {
      this.selectedWaybillArray = []
    },
    changePage(value) {
      this.perPage = value
    },
    handleChangePage(page) {
      this.page = page
      this.fetchOrderList()
    },
    onClickViewOrder(id) {
      if (this.$can('show-orders')) {
        this.$refs.viewOrderModal.openModal(id)
      }
    },
    onClickRefresh() {
      this.fetchOrderList()
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        // If the "Select All" checkbox is checked, select all waybill numbers.
        this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
      } else {
        this.selectedWaybillArray = []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../@core/scss/button-color.scss';
</style>
